import { Grid, Space } from "../Layout";
import { Texts, Title, Media, Button, Link } from "../Object";

const Service = (props) => {
  return (
    <>
      <Space size={["160px 0 120px", "72px 0 72px"]}>
        <div className="l-row">
          <Title slug="service"></Title>
          <Space size={["100px auto 0", "64px auto 0"]}>
            <List />
          </Space>
        </div>
      </Space>
    </>
  );
}

const Item = (props) => {
  const gridProps = {
    wrap: {
      gap: ["32px", '24px'],
      layout: ["100%", ""],
      size: ["100%"],
      dir: ["row"],
    },
    texts: {
      gap: ['8px'],
      layout: ['100%'],
      size: ['100%'],
      dir: ['row']
    },
    button: {
      gap: ['12px'],
      layout: ['1fr 16px'],
      dir: ['column']
    }
  };
  return (
    <>
      <Button class="" link={`service/#item${props.index}`} linkType="hash">
        <li className="item p-service__wrap--button">
          <Grid {...gridProps.wrap}>
            <Media class="p-service__img--icon" src={`service/list${props.index}`} alt="icon illust"></Media>
            <Grid {...gridProps.texts}>
              <Texts class="c-text--en c-text--bold" slug={`service/title-en${props.index}`}></Texts>
              <object>
                <Button link={`/service#item${props.index}`} linkType="hash">
                  <div className="p-service__wrap--title">
                    <Grid {...gridProps.button}>
                      <Texts slug={`service/title-jp${props.index}`}></Texts>
                      <Media class="p-img__arrow--list" src="common/icon-list-arrow" alt=">"></Media>
                    </Grid>
                  </div>
                </Button>
              </object>
            </Grid>
          </Grid>
        </li>
      </Button>
    </>
  );
};

let items = [];
for (let i = 0; i < 3; i++) {
  items.push(<Item key={i} index={i}></Item>);
}

const List = (props) => {
  const gridProps = {
    list: {
      dir: ["column", "row"],
      size: "100%",
      layout: ["repeat(3, 1fr)", "100%"],
      gap: ["64px", "32px"],
    },
  };

  return (
    <>
      <ul className="list">
        <Grid {...gridProps.list}>{items}</Grid>
      </ul>
    </>
  );
};

export default Service;